import { render, staticRenderFns } from "./dangerMasterDetail.vue?vue&type=template&id=33d782f2"
import script from "./dangerMasterDetail.vue?vue&type=script&lang=js"
export * from "./dangerMasterDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33d782f2')) {
      api.createRecord('33d782f2', component.options)
    } else {
      api.reload('33d782f2', component.options)
    }
    module.hot.accept("./dangerMasterDetail.vue?vue&type=template&id=33d782f2", function () {
      api.rerender('33d782f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/chm/danger/dangerMasterDetail.vue"
export default component.exports